import axios from "axios";
import { toast } from "react-toastify";
import { handleEncryptData } from "./EncryptionService"; // Import encryption and decryption services
import { handleDecryptData } from "./DecryptionService";

const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL_BACKEND,
});

// Request interceptor to add the access token to the headers
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("accessToken");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle token refresh
api.interceptors.response.use(
    (response) => response, // Return the response if no error
    async (error) => {
        const originalRequest = error.config;

        // If the error is a 401 and the request has not been retried yet
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

                try {
                    // Get the refresh token from localStorage
                    const refreshToken = localStorage.getItem("refreshToken");

                    if (!refreshToken) {
                        throw new Error("Refresh token not available");
                    }

                // Encrypt the refresh token
                const encryptedToken = handleEncryptData({ refreshToken });

                // Request a new access token
                const response = await axios.post(`${process.env.REACT_APP_BASE_URL_BACKEND}api/user/refreshToken`, encryptedToken);

                // Decrypt the new access token
                const decryptedData = handleDecryptData(response?.data?.cipher);
                // Ensure decryptedData is an object and contains the accessToken
                if (decryptedData && decryptedData?.data?.accessToken) {
                    const newAccessToken = decryptedData?.data?.accessToken;

                    // Store the new token in localStorage
                    localStorage.setItem("accessToken", newAccessToken);

                    // Retry the original request with the new token
                    originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                    return api(originalRequest); // Retry the original request
                } else {
                    throw new Error("Decryption failed or accessToken not found");
                }
            } catch (refreshError) {
                // Handle token refresh failure
                toast.error("Session expired. Please log in again.");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("refreshToken");
                // window.location.href = "/login"; // Redirect to login page
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default api;
